import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import MenuBar from "../components/menuBar/MenuBar";
import AlertProvider from "../context/AlertContext";
import { AuthProvider } from "../context/AuthContext";
import AdminInfoProvider from "../context/AdminInfoContext";
import AdminInfoBar from "../components/menuBar/AdminInfoBar";
import ArchieChatWidget from "../components/archie/ArchieChatWidget";
import { HideBehindFeature } from "../components/common/FeatureFlags/HideBehindFeature";
import { FeatureFlagName } from "../types/feature-flags/featureFlag";
import useVerifyAuth from "../hooks/useVerifyAuth";

export default function Root() {
  useVerifyAuth();

  return (
    <AlertProvider>
      <AuthProvider>
        <AdminInfoProvider>
          <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
            <MenuBar sx={{ flexGrow: 0 }} />
            <AdminInfoBar />
            <Box className="flex flex-col flex-1 overflow-y-auto" p={2}>
              <Outlet />
            </Box>
            <HideBehindFeature name={FeatureFlagName.Archie}>
              <ArchieChatWidget />
            </HideBehindFeature>
          </Box>
        </AdminInfoProvider>
      </AuthProvider>
    </AlertProvider>
  );
}
